<template>
  <div class="user-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>用户管理</span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="关键词">
          <el-input v-model="searchForm.keyword" placeholder="请输入用户名/手机号/昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userList" style="width: 100%">
        <el-table-column prop="id" label="ID" min-width="60"></el-table-column>
        <el-table-column prop="username" label="用户名" min-width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="110"></el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="100"></el-table-column>
        <el-table-column prop="gender" label="性别" min-width="60">
          <template #default="scope">
            {{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' : '未知' }}
          </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" min-width="60"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="80">
          <template #default="scope">
            <el-switch v-model="scope.row.status" @change="handleStatusChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" min-width="140">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleDetail(scope.row.id)">详情</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 用户详情对话框 -->
    <el-dialog :visible.sync="detailDialogVisible" title="用户详情" width="600px">
      <el-form :model="userDetail" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="userDetail.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userDetail.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="userDetail.nickname" disabled></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input :value="userDetail.gender === 1 ? '男' : userDetail.gender === 2 ? '女' : '未知'" disabled></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="userDetail.age" disabled></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-input :value="formatDate(userDetail.created_at)" disabled></el-input>
        </el-form-item>
        <el-form-item label="最后登录">
          <el-input :value="formatDate(userDetail.last_login_at)" disabled></el-input>
        </el-form-item>
        <el-form-item label="统计信息">
          <el-card v-if="userDetail.stat">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="stat-item">
                  <div class="stat-label">总记录数</div>
                  <div class="stat-value">{{ userDetail.stat.total_records || 0 }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="stat-item">
                  <div class="stat-label">总信件数</div>
                  <div class="stat-value">{{ userDetail.stat.total_letters || 0 }}</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="stat-item">
                  <div class="stat-label">总点赞数</div>
                  <div class="stat-value">{{ userDetail.stat.total_likes || 0 }}</div>
                </div>
              </el-col>
            </el-row>
          </el-card>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'UserList',
  data() {
    return {
      userList: [],
      userDetail: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { keyword: '' },
      detailDialogVisible: false
    }
  },
  mounted() {
    this.fetchUserList()
  },
  methods: {
    // 获取用户列表
    fetchUserList() {
      api.get('/admin/user/list', {
        page: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchForm.keyword
      })
      .then(data => {
        this.userList = data.data.list
        this.total = data.data.total
      })
      .catch(error => {
        this.$message.error(error.message || '获取用户列表失败')
      })
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchUserList()
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchUserList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchUserList()
    },

    // 查看用户详情
    handleDetail(id) {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/user/detail?id=${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.userDetail = data.data
            this.detailDialogVisible = true
          }
        })
      } catch (error) {
        this.$message.error('获取用户详情失败')
      }
    },

    // 删除用户
    handleDelete(id) {
      this.$confirm('确定要删除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/user/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchUserList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 切换状态
    handleStatusChange(row) {
      try {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/user/toggle-status', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id: row.id, status: row.status })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code !== 0) {
            row.status = !row.status
            this.$message.error(data.message)
          }
        })
      } catch (error) {
        row.status = !row.status
        this.$message.error('操作失败')
      }
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.user-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.stat-item {
  text-align: center;
  padding: 10px;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}
</style>
